<template>
<div style="width: 100%; overflow-x: auto; padding-bottom:20px;">
  <v-data-table
    :loading               = "mList.loading"
    :headers               = "mHeaders"
    :items                 = "mList.items"
    :options.sync          = "options"
    :server-items-length   = "mList.totalCount"
    :page.sync             = "mList.pageNo"
    :items-per-page        = "mList.pageSize"

    @update:options        = "onUpdateOption"

    class                  = "imd-sm-table"

    loading-text           = "검색 중 입니다."
    locale                 = "ko-KR"
    :no-data-text          = "noDataMsg"
    no-results-text        = "결과가 없습니다"
    :hide-default-header   = "typeof $scopedSlots['header'] !== 'undefined'"

    dense
    hide-default-footer

    :headerThClass = "headerThClass"
  >
    <!-- 헤더 -->
    <template v-slot:header="header"
      v-if="typeof $scopedSlots['header'] !== 'undefined'"> <!-- 미지정시 원래 스타일을 사용한다. -->
      <thead class="v-data-table-header">
        <slot name="header" :header="header"></slot>
      </thead>
    </template>

    <!-- 목록 -->
    <template v-slot:item="props">
      <slot name="item" v-bind="props">
        <tr @click="doItemClick(props.item, $event)"
            :class="{ 'selectTr' : isCurrentItem(props.item) }">
          <template v-for="(h,i) in mHeaders">
            <td v-if="typeof $scopedSlots['td_'+h.value] !== 'undefined'" :align="h.align"  :key="i">
              <slot :name="['td_'+h.value]" :value="props.item[h.value]" :item="props.item" :i="props.index"
                :_no="mList.totalCount - ((mList.pageNo -1) * mList.pageSize) - props.index" />
            </td>
            <td v-else-if="typeof $scopedSlots['item.'+h.value] !== 'undefined'" :align="h.align"  :key="i">
              <slot :name="['item.'+h.value]" :value="props.item[h.value]" :item="props.item" :i="props.index"
                :_no="mList.totalCount - ((mList.pageNo -1) * mList.pageSize) - props.index" />
            </td>
            <td v-else
              :align="h.align"
              :key="i"
              :style="{
                'white-space' : h.nowrap
              }" >{{ props.item[h.value] }}</td>
          </template>
          <!-- 'white-space' : props.item[h.nowrap] == 'nowrap' ? 'nowrap' : false -->
        </tr>
      </slot>
    </template>

    <!-- 빈칸 체우기 : items 있을때만 -->
    <template v-slot:body.append="props">
      <slot name="body.append" v-bind="props">
        <tr v-for="i in leftCount" :key="i">
          <td v-for="j in mHeaders.length" :key="j"></td>
        </tr>
      </slot>
      <slot name="table-footer"></slot>
    </template>

    <!-- 데이터 없음 -->
<!--
    <template v-slot:no-data>
      <template v-if="mList.loading">
        <tr :height="options.itemsPerPage * 29"><td align="center"
          :colspan="mHeaders.length"
          > 검색중..</td> </tr>
      </template>
      <slot v-else name="no-data">
        <tr v-for="i in options.itemsPerPage" :key="i">
          <td v-for="j in mHeaders.length" :key="j"></td>
        </tr>
      </slot>
    </template>
-->

    <!-- 결과 없음 -->
    <template v-slot:no-results>
      <template v-if="mList.loading">
        <tr :height="options.itemsPerPage * 29"> <td align="center"
          :colspan="mHeaders.length"
          > 검색중..</td> </tr>
      </template>
      <slot v-else name="no-results">
        <tr> <td align="center" :colspan="mHeaders.length"> 결과가 없습니다. </td> </tr>
        <tr v-for="i in options.itemsPerPage - 1" :key="i">
          <td v-for="j in mHeaders.length" :key="j"></td>
        </tr>
      </slot>
    </template>

    <!-- 푸터 : 페이징  -->
    <template v-slot:footer>
      <slot name="footer">

        <div class="s-tbl-footer-wrap" v-if="!hideFooter">
          <div class="s-tbl-footer-center text-xs-center">
            <s-page v-if="totPages && totPages > 1"
                    v-model="mList.pageNo"
                    :length="totPages"
                    style="padding:0; margin:0;"
                    :total-visible="mList.showPageSize"
              />
          </div>
          <div v-if="totCnt && totCnt >= 0" class="s-tbl-footer-left">
              총 {{ totCnt | comma }} {{ unitName }}
          </div>
          <div class="s-tbl-footer-right" v-if="!onepage">
              페이지당 줄 수
                <i-input-sel style="width: 60px;"
                  v-model="mList.pageSize"
                  :items="[10,15,20,30,40,50,70,100,200,500,1000,2000,10000]"
                />
          </div>
        </div>
      </slot>
    </template>

  </v-data-table>
</div>
</template>

<script>
const isDebug = false
export default {
  inheritAttrs: false,
  props: {
    list: Object,
    listApi: String,
    listParam: Function,
    listRes: Function,
    keys: String,
    headers: String,

    detail: Object,
    detailApi: String,
    detailParam: Function,
    hideEmptyTr: { type: Boolean, default: false, },
    onepage: { type: Boolean, default: false, },
    hideFooter: { type: Boolean, default: false, },
    headerThClass: {},
    unitName: { type: String, default: '명'},
  },
  data () {

    const headers = this.headers || this.list.headers

    let mList = {
      loading     : false,
      detail_loading : false,

      keys        : this.keys || this.list.keys,
      showPageSize: this.list.showPageSize || 10,
      pageSize    : this.list.pageSize     || 10,
      pageNo      : this.list.pageNo       || 1,
      totalCount  : this.list.totalCount   || -1,
      items       : this.list.items        || [],
      headers     : (typeof headers === "object" ? headers :
                     typeof headers === "string" ? T.makeJson(headers) : null),
      sitem       : null, // doItemClick 으로 선택한 아이템
      // loadData    : this.list.loadData, // 데이터 조회 콜백
      // itemClick   : this.list.itemClick, // tr 클릭 콜백
    }
    let options = {
        itemsPerPage: mList.pageSize,
        page: mList.pageNo
    }
    isDebug && console.log("[s-table3] mList 를 초기화 합니다.", mList, options);
    return {
      mList,
      options,
      keys_array: null,
      mHeaders: [],
      optChanged : 0,
    }
  },
  computed: {
    totPages() { // 총 페이지 수 계산
      return Math.ceil(this.totCnt / this.options.itemsPerPage)
    },
    totCnt() {
      return this.mList.totalCount || this.mList.items && this.mList.items.length
    },
    leftCount() { // tr 빈줄 체우기
      if (this.onepage || this.hideEmptyTr) return 0 // 빈줄감추기 옵션지정이면 빈줄은 무조건 0
      const showItems = this.mList && this.mList.items && this.mList.items.length || 0 // 현재 출력된 아이템 수
      const perItems =  this.options.itemsPerPage // 최대 보여줄 아이템 수
      let cnt = Math.max(perItems - showItems, 0) // 모자란 줄 수
      if (!this.mList.items || this.mList.items.length < 1) cnt-- // 데이터가 하나도 없을땐 첫줄에 뭐라뭐라 메세지가 나오므로 그거 한줄은 빼준다
      return (perItems > 50 && showItems > 50) ? 0 : cnt // 50 줄이 넘어갈 경우에는 페이지달 줄 수를 무시한다.
    },
    noDataMsg() {
      const v = this.mList.totalCount
      return v === undefined || v == null || v < 0 ? "검색 전 입니다." : "결과가 없습니다."
    }
  },
  created() {
    const keys = this.keys || this.list.keys
    if (keys) {
      this.keys_array = keys.trim().split(/\s*,\s*/)
    }
    this.$emit('update:list', this.mList)
    this.copyHeaders()
  },
  methods: {
    doSearch() {
      this.load()
      return this
    },
    load() { // 첫 페이지로 로딩
      this.mList.pageNo == 1 && this.emitPageChange() || (this.mList.pageNo = 1)
      return this
    },
    reload() { // 현재 페이지 로딩
      this.emitPageChange()
      return this
    },
    clearDetail(initObj) { // 상세 클리어
      this.sitem = initObj === undefined ? {} : initObj
      this.$ui.inputErrorClear()
      this.$emit('update:detail', this.sitem)
      return this
    },
    doItemClick(item, $event) { // row 클릭
      this.mList.sitem = item
      this.$emit("itemClick", item, $event)
      this.loadDetail(item)
      return this
    },
    loadDetail(param) { // 상세 로딩
      if (!this.detailApi) return // 상세기능 설정이 없으면 PASS
      if (_.isEmpty(param)) {
        this.$emit("update:detail", {})
        return
      }
      this.mList.detail_loading = true
      const params = this.detailParam(param);
      this.$ui.httpGet(this.detailApi, params,
        ret => {
          this.$emit("update:detail", _.get(ret, "data.rs1[0]"))
        }, null,
        () => this.mList.detail_loading = false
      )
      return this
    },
    clear() { // mList 클리어
      this.mList.totalCount = -1
      this.mList.items = []
      this.mList.loading = false
      this.sitem = null
      return this
    },
    onUpdateOption(n) { // 옵션이 업데이트 되었나 ? ( 페이징 ㄱㄱ )
      isDebug && console.log("[s-table3] event onUpdateOption = ",n);
      if (this.optChanged++ < 1) {
        // 최초 한번은 옵션 셋팅이므로 무시한다.
        return
      }
      this.emitPageChange()
    },
    emitPageChange() { // 페이징 변경시 데이터를 로딩한다.
      isDebug && console.log("[s-table3] emitPageChange() options = ", this.options);
      const mList = this.mList
      mList.pageNo     = this.options.page
      mList.pageSize   = this.options.itemsPerPage
      mList.orderBy    = this.options.sortBy
      mList.orderDesc  = this.options.descending

      this.$emit('update:list', this.mList)
      this.$emit("loadData", mList)

      if (this.listParam) {
        const params = this.listParam(mList)
        this.$ui.httpGetList(this.mList, this.listApi, params, this.listRes)
      }
    },
    copyHeaders() { // mList.headers 를 복사한다. 복사하면서 sortable 가 true가 아닌경우 false로 지정한다.
      if (this.mList.headers) {
        this.mHeaders = this.mList.headers.map(e=> {
          e.sortable = e.sortable || e.sortable == "true" || false
          return e;
        })
      } else {
        this.mHeaders = []
      }
    },
    isCurrentItem(item) { // keys 가 지정되어 있을때 그게 현재 아이템인지 판단한다.
      if (!this.keys_array || !this.mList.sitem || !item) return false
      return this.keys_array.every(key => item[key] == this.mList.sitem[key])
    },
  },
  watch: {
    'mList.headers' () {
      this.copyHeaders()
    },
    'mList.pageSize'(v) { // 페이지 사이즈 변경
      isDebug && console.log("[s-table3] 페이지 사이즈 변경됨 :", v);
      this.options.page = this.mList.pageNo = 1
      this.options.itemsPerPage = v
      this.emitPageChange()
    },
  },
}
</script>

<style>
th.test01 {
  background-color: #F3F3F3 !important;
  color: #222222 !important;
}
</style>